<script>
import {getLibrayBannerApi} from '../../../api/technology'
import qs from 'qs'

export default {
  name: 'TechnologyBanner',
  data() {
    return {
      imageList: []
    }
  },
  created() {
    this.getLibrayBanner()
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    getImageUrl() {
      return (item) => {
        // 首先检查是否存在pictureMaterial.url
        if (item.pictureMaterial && item.pictureMaterial.url) return item.pictureMaterial.url
        // 如果没有，则尝试使用materialDetail.materialThumbnail
        else if (item.materialDetail && item.materialDetail.materialThumbnail) return item.materialDetail.materialThumbnail
        // 如果两者都没有，可以返回一个默认图片或空字符串
        return ''
      }
    },
    getFunctionName() {
      return (image) => {
        if (!image.linkUrl) return
        const urlParamsStr = image.linkUrl.split('?')[1]
        const urlParams = qs.parse(urlParamsStr)
        const fileId = urlParams.fileId
        const entrance = urlParams.entrance
        if (!entrance) return
        if (image.linkUrl.indexOf('technologyFCSW') > -1) return `房颤问卷-banner-${entrance}`
        else if (image.linkUrl.indexOf('carto30h5') > -1) return `carto30h5-banner-${entrance}`
        else return `新技术-Banner-${fileId}-${entrance}`
      }
    }
  },
  methods: {
    async getLibrayBanner() {
      try {
        const res = await getLibrayBannerApi()
        if (res.code === 0) {
          this.imageList = res.data
        }
      } catch (e) {
        throw e
      }
    },
    liveClick(image) {
      // 如果 linkUrl 不存在，直接返回
      if (!image.linkUrl) return
      try {
        const urlParamsStr = image.linkUrl.split('?')[1]
        const urlParams = qs.parse(urlParamsStr)
        const fileId = urlParams.fileId
        const entrance = urlParams.entrance
        if (!entrance) return
        const userId = this.userInfo.id
        sessionStorage.setItem('traceObj', JSON.stringify({
          functionUrl: image.linkUrl,
          note: urlParamsStr + `&userId=${userId}`
        }))
        window.sessionStorage.setItem('serviceId', fileId || '')
        window.sessionStorage.setItem('entrance', entrance)
        this.$router.push(image.linkUrl)
      } catch (error) {
        // 捕获并处理 URL 解析异常
        console.error('Invalid URL format:', error)
      }
    }
  }
}
</script>

<template>
  <div class="banner">
    <van-swipe indicator-color="#ff7721" autoplay="2000">
      <van-swipe-item v-for="image in imageList" :key="image.id"
                      v-track="{ functionName: getFunctionName(image) }"
                      @click.stop="liveClick(image)">
        <img :src="getImageUrl(image)" :alt="`轮播图片 ${image.id}`"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<style scoped lang="less">
.banner {
  width: calc(100vw - 30px);
  height: 187px;
  border-radius: 12px;
  margin: 0 auto;

  /deep/ .van-swipe {
    border-radius: 12px;
  }

  /deep/ .van-swipe__indicators {
    bottom: 10px;
  }

  /deep/ .van-swipe__indicator:not(:last-child) {
    margin-right: 3px;
  }

  img {
    width: 100%;
    height: 187px;
    border-radius: 12px;
    object-fit: cover;
  }

  /deep/ .van-swipe__track {
    border-radius: 12px;
    height: 187px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/technology/modules/TechnologyBanner.vue